import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from "react-intl";
import { CODE_TYPE } from 'constants/common';
import { MyTag } from 'components/Atoms';

const AppliedCodeSection = ({ codeType, codeValue, codeError, className }) => {
  const text = codeError && codeError.code
    ? <FormattedMessage id={`error.message.${codeError.code}`} />
    : codeType?.toLowerCase() === CODE_TYPE.VOUCHER
    ? <FormattedMessage id="applied_discount_code.voucher" values={{ codeValue: codeValue }} />
    : <FormattedMessage id="applied_discount_code.discount" values={{ codeValue: codeValue }} />;

  return (
    <MyTag
      className={cn(
        'mt-24 w-100p d-flex response-tag',
        `${codeError ? 'failed' : 'completed'}`,
        className
      )}
    >
      <span>{text}</span>
    </MyTag>
  );
};

export default AppliedCodeSection;
